/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *1
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { useLayoutEffect } from 'react';

var useUnpin = function useUnpin(_ref) {
  var unpin = _ref.unpin,
      navigationBarRef = _ref.navigationBarRef,
      menuRef = _ref.menuRef;

  var handleClick = function handleClick(event) {
    var isTarget = menuRef && menuRef.contains(event.target) || navigationBarRef.current && navigationBarRef.current.contains(event.target);

    if (!isTarget) {
      event.preventDefault();
      event.stopPropagation();
      unpin();
    }
  };

  useLayoutEffect(function () {
    document.addEventListener('click', handleClick, true);
    return function () {
      document.removeEventListener('click', handleClick, true);
    };
  }, [navigationBarRef, menuRef]);
};

export default useUnpin;